<template>
<div>
  <router-link :to="{path:'StoreProfile',query:{VendorID:item.VendorID}}" class="bg-white text-center p-2 rounded-lg d-block">
    <v-avatar>
      <img :src="$replaceHttps(item.PictureLogoUrl)" alt="لوگو فروشگاه">
    </v-avatar>
    <div class="text-truncate mt-4 font-weight-bold min-height-20px">{{ item.Name }}  <i v-if="item.IsVerified" class="fa-solid fa-badge-check mr-1"></i></div>
    <div class="text-truncate font12px m-0 bio-text" v-html=" item.Bio"></div>
    <div class="primary-text mt-1"><i class="fa-solid fa-star yellow--text"></i>{{ item.Rate }}</div>
    <v-btn :class="isFollow ? true :'black--text'" :color="isFollow ? 'primary':'secondary'" block class="rounded-lg mt-3" depressed
           small @click.stop.prevent="follow">
      <span v-if="isFollow">دنبال شد</span>
      <span v-else>دنبال کردن</span>
    </v-btn>
  </router-link>
  <v-overlay :value="showLoaderDialog">
    <div class="loading-spinner">
    </div>
  </v-overlay>
  <v-snackbar
      v-model="showResult"
      :multi-line="true"
      color="primary">
    {{ resultText }}

    <template v-slot:action="{ attrs }">
      <v-btn v-bind="attrs" icon @click="showResult = false ">
        <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
      </v-btn>
    </template>
  </v-snackbar>

</div>
</template>

<script>
export default {
  name: "StoreCard",
  props: ['item'],
  data: () => ({
    isFollow: null,
    resultText: null,
    showLoaderDialog:false,
    showResult:false,
  }),
  mounted() {
    this.checkUserFollowing()
  },
  methods: {
    checkUserFollowing() {
      let following = this.$store.getters.getUserFollowings
      let id = this.item.VendorID

      if (following.find(x => x.VendorID === id) !== undefined) {
        this.isFollow = true
      }
    },

    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
    follow() {
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorID",  this.item.VendorID);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetFollowVendor", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              this.isFollow = !this.isFollow
              let payload  = {id:this.item.VendorID ,type:2}
              this.$store.commit('addOrRemoveFollowingItemToList', payload)
            }
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    },
  }
}
</script>

<style scoped>

</style>
